
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const AdminPermission = {
  PROMOTIONS: 'PROMOTIONS',
  MARGINS: 'MARGINS',
  ALLOTMENTS: 'ALLOTMENTS',
  PLANNING_MANAGER: 'PLANNING_MANAGER',
  CALENDAR_SYNC_OBSERVER: 'CALENDAR_SYNC_OBSERVER',
  AIRPORTS: 'AIRPORTS',
  COMPANIES: 'COMPANIES',
  SLIDES: 'SLIDES',
  MANAGE_USERS: 'MANAGE_USERS',
  MARKETING: 'MARKETING',
  MARKETING_PUBLISH: 'MARKETING_PUBLISH',
  STATS_BOOKINGS: 'STATS_BOOKINGS',
  STATS_COLLABORATORS: 'STATS_COLLABORATORS',
  STATS_IGA: 'STATS_IGA',
  STATS_NEW_TRAVELERS: 'STATS_NEW_TRAVELERS',
  PLANNING_MRS: 'PLANNING_MRS',
  PLANNING_RUN: 'PLANNING_RUN',
  BOOKING_HISTORY: 'BOOKING_HISTORY',
  BOOKING_DELETE: 'BOOKING_DELETE',
  CHATBOT: 'CHATBOT'
}



export const AdminRole = {
  SUPERADMIN: 'SUPERADMIN',
  ADMIN: 'ADMIN'
}



export const AeoRunStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  DONE: 'DONE',
  FAILED: 'FAILED'
}



export const AeoEngine = {
  OPENAI: 'OPENAI',
  GEMINI: 'GEMINI',
  ANTHROPIC: 'ANTHROPIC'
}



export const AeoSentiment = {
  POSITIVE: 'POSITIVE',
  NEUTRAL: 'NEUTRAL',
  NEGATIVE: 'NEGATIVE'
}



export const DocumentContentType = {
  FILE: 'FILE',
  URL: 'URL'
}



export const Agency = {
  MRS: 'MRS',
  RUN: 'RUN'
}



export const AlertType = {
  NEW_BOOKING: 'NEW_BOOKING',
  BOOKING_FULLY_PAID: 'BOOKING_FULLY_PAID',
  FIRST_DEPOSIT_PAID: 'FIRST_DEPOSIT_PAID',
  DEPOSIT_OVERDUE_60: 'DEPOSIT_OVERDUE_60',
  BALANCE_DUE_45: 'BALANCE_DUE_45',
  BALANCE_DUE_12: 'BALANCE_DUE_12',
  INSTALLMENT_PAYMENT_FAILED: 'INSTALLMENT_PAYMENT_FAILED',
  BOOKING_OVERPAID: 'BOOKING_OVERPAID',
  SPECIFICITY: 'SPECIFICITY',
  WEEKEND_BOOKING_ALERT: 'WEEKEND_BOOKING_ALERT',
  COMPANY_DEADLINE_MISSING: 'COMPANY_DEADLINE_MISSING',
  NEW_RESERVATION_REQUEST: 'NEW_RESERVATION_REQUEST',
  ESTIMATE_DECLINED: 'ESTIMATE_DECLINED',
  ESTIMATE_MODIFICATION_REQUESTED: 'ESTIMATE_MODIFICATION_REQUESTED',
  ESTIMATE_SIMILAR_REQUESTED: 'ESTIMATE_SIMILAR_REQUESTED',
  SMS_REPLY_RECEIVED: 'SMS_REPLY_RECEIVED'
}



export const AuthSubjectType = {
  USER: 'USER',
  ADMIN: 'ADMIN'
}



export const BookingSessionStep = {
  FLIGHT_SELECTED: 'FLIGHT_SELECTED',
  PASSENGERS_FILLED: 'PASSENGERS_FILLED',
  INSURANCE_DECIDED: 'INSURANCE_DECIDED',
  PAYMENT_INITIATED: 'PAYMENT_INITIATED',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED'
}



export const BookingSessionInsuranceEstimateStatus = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
}



export const BookingStatus = {
  AWAITING_DEPOSIT: 'AWAITING_DEPOSIT',
  DEPOSIT_PAID: 'DEPOSIT_PAID',
  FULLY_PAID_PENDING: 'FULLY_PAID_PENDING',
  FULLY_PAID_TRAVELED: 'FULLY_PAID_TRAVELED',
  CANCELLED: 'CANCELLED'
}



export const BookingTravelType = {
  FLIGHT: 'FLIGHT',
  TOURISM: 'TOURISM'
}



export const PaymentType = {
  DEPOSIT: 'DEPOSIT',
  INSTALLMENT: 'INSTALLMENT',
  FULL: 'FULL',
  INSURANCE: 'INSURANCE',
  LEGACY_DEPOSIT: 'LEGACY_DEPOSIT'
}



export const PaymentStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED'
}



export const PaymentMethod = {
  CREDIT_CARD: 'CREDIT_CARD',
  CREDIT_CARD_AXEPTA: 'CREDIT_CARD_AXEPTA',
  PAY_BY_LINK: 'PAY_BY_LINK',
  BON_LADOM: 'BON_LADOM',
  BON_CONTINUITE: 'BON_CONTINUITE',
  BANK_TRANSFER: 'BANK_TRANSFER',
  BANK_TRANSFER_BNPRUN: 'BANK_TRANSFER_BNPRUN',
  CASH: 'CASH',
  CHEQUE: 'CHEQUE',
  VACATION_CHEQUE: 'VACATION_CHEQUE',
  VACATION_E_CHEQUE: 'VACATION_E_CHEQUE',
  INSTALLMENTS: 'INSTALLMENTS',
  AVOIR: 'AVOIR',
  REFUND: 'REFUND'
}



export const PaymentProvider = {
  FLOA: 'FLOA',
  SSP: 'SSP'
}



export const BookingSource = {
  AFFIDIUM_IMPORT: 'AFFIDIUM_IMPORT',
  RESERVATION: 'RESERVATION',
  CHECKOUT: 'CHECKOUT'
}



export const PaymentSource = {
  WEBSITE: 'WEBSITE',
  MANUAL: 'MANUAL'
}



export const InstallmentSnapshotSource = {
  CHECKOUT: 'CHECKOUT',
  ESTIMATE: 'ESTIMATE',
  AFFIDIUM_IMPORT: 'AFFIDIUM_IMPORT'
}



export const IgaSyncStatus = {
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  SYNCED: 'SYNCED',
  FAILED: 'FAILED'
}



export const IgaAccount = {
  WEB: 'WEB',
  WSMASSILIA1: 'WSMASSILIA1',
  WSMASSILIA2: 'WSMASSILIA2',
  WSMASSILIA4: 'WSMASSILIA4'
}



export const BookingMarginRole = {
  ALLOTMENT: 'ALLOTMENT',
  NORMAL: 'NORMAL'
}



export const EventStatus = {
  CONFIRMED: 'CONFIRMED',
  TENTATIVE: 'TENTATIVE',
  CANCELLED: 'CANCELLED'
}



export const CancellationFeeRuleMode = {
  KEEP_API: 'KEEP_API',
  OVERRIDE_FIXED_FEE: 'OVERRIDE_FIXED_FEE',
  OVERRIDE_NON_ALLOWED: 'OVERRIDE_NON_ALLOWED',
  OVERRIDE_TIME_WINDOW: 'OVERRIDE_TIME_WINDOW',
  API_FEE_PLUS_FIXED_IF_REFUNDABLE_NUMERIC: 'API_FEE_PLUS_FIXED_IF_REFUNDABLE_NUMERIC',
  KEEP_API_UNLESS_FREE: 'KEEP_API_UNLESS_FREE',
  FIXED_FEE_IF_EXCHANGE_FREE: 'FIXED_FEE_IF_EXCHANGE_FREE'
}



export const ClientType = {
  INDIVIDUAL: 'INDIVIDUAL',
  COMPANY: 'COMPANY'
}



export const EmailStatus = {
  QUEUED: 'QUEUED',
  SENDING: 'SENDING',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  BOUNCED: 'BOUNCED',
  FAILED: 'FAILED'
}



export const DocumentType = {
  E_TICKET: 'E_TICKET',
  ESTIMATE: 'ESTIMATE',
  INSURANCE: 'INSURANCE',
  INVOICE: 'INVOICE',
  RESERVATION_CONTRACT: 'RESERVATION_CONTRACT'
}



export const FlightType = {
  ONE_WAY: 'ONE_WAY',
  ROUND_TRIP: 'ROUND_TRIP',
  MULTI_DESTINATION: 'MULTI_DESTINATION'
}



export const TravelClass = {
  ECONOMY: 'ECONOMY',
  BUSINESS: 'BUSINESS',
  PREMIUM: 'PREMIUM'
}



export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
}



export const TourismType = {
  STAY: 'STAY',
  CRUISE: 'CRUISE',
  TOUR: 'TOUR'
}



export const PensionType = {
  ALL_INCLUSIVE: 'ALL_INCLUSIVE',
  FULL_BOARD: 'FULL_BOARD',
  HALF_BOARD: 'HALF_BOARD',
  BREAKFAST: 'BREAKFAST',
  ROOM_ONLY: 'ROOM_ONLY'
}



export const NewsletterSubscription = {
  YES: 'YES',
  NO: 'NO',
  ALREADY_SUBSCRIBED: 'ALREADY_SUBSCRIBED'
}



export const EstimateDeclineReason = {
  TOO_EXPENSIVE: 'TOO_EXPENSIVE',
  DATES_NOT_SUITABLE: 'DATES_NOT_SUITABLE',
  OTHER: 'OTHER',
  OTHER_OFFER_ACCEPTED: 'OTHER_OFFER_ACCEPTED'
}



export const ClientActionChannel = {
  PORTAL: 'PORTAL',
  PUBLIC_LINK: 'PUBLIC_LINK',
  SYSTEM: 'SYSTEM'
}



export const SyncOperation = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
}



export const SyncStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
}



export const InstallmentDepositProfile = {
  E0: 'E0',
  E1: 'E1',
  E2: 'E2',
  E4: 'E4',
  E5: 'E5',
  NONE: 'NONE'
}



export const InstallmentDeadlineFormula = {
  MIN_BASE_LD_OPW: 'MIN_BASE_LD_OPW',
  MIN_BASE_OPW: 'MIN_BASE_OPW',
  TICKETING_DEADLINE: 'TICKETING_DEADLINE'
}



export const InsuranceEstimatedBy = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT'
}



export const InsuranceDevisStatus = {
  NONE: 'NONE',
  QUOTE_PENDING: 'QUOTE_PENDING',
  QUOTE_CREATED: 'QUOTE_CREATED',
  QUOTE_FAILED: 'QUOTE_FAILED',
  CONTRACT_CONFIRMED: 'CONTRACT_CONFIRMED',
  CONTRACT_FAILED: 'CONTRACT_FAILED',
  CONTRACT_CANCELLED: 'CONTRACT_CANCELLED'
}



export const LoadingSlideRouteRole = {
  ORIGIN: 'ORIGIN',
  DESTINATION: 'DESTINATION'
}



export const MarginType = {
  DESTINATION_FROM_TO_FRANCE: 'DESTINATION_FROM_TO_FRANCE',
  DESTINATION_OTHER_TO_OTHER: 'DESTINATION_OTHER_TO_OTHER',
  COMPANY: 'COMPANY',
  ALLOTMENT: 'ALLOTMENT',
  NEGOTIATED_RATE: 'NEGOTIATED_RATE'
}



export const MarginValueType = {
  FIXED: 'FIXED',
  PERCENTAGE: 'PERCENTAGE'
}



export const FareType = {
  Public: 'Public',
  TourOperator: 'TourOperator',
  NegoFare: 'NegoFare',
  VisitingFriends: 'VisitingFriends',
  ContractBulk: 'ContractBulk',
  Emigrant: 'Emigrant'
}



export const MarginRouteRole = {
  ORIGIN: 'ORIGIN',
  DESTINATION: 'DESTINATION'
}



export const AllotmentDirection = {
  OUTBOUND: 'OUTBOUND',
  RETURN: 'RETURN'
}



export const MarketingContentStatus = {
  PENDING: 'PENDING',
  GENERATING: 'GENERATING',
  REVIEW: 'REVIEW',
  PARTIALLY_SENT: 'PARTIALLY_SENT',
  SENT: 'SENT',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED'
}



export const MarketingImageStatus = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  GENERATING: 'GENERATING',
  FAILED: 'FAILED'
}



export const MarketingAudience = {
  FAMILLE: 'FAMILLE',
  COUPLE: 'COUPLE',
  SENIOR: 'SENIOR',
  GROUPE: 'GROUPE'
}



export const GeneratedImageStatus = {
  PENDING: 'PENDING',
  DONE: 'DONE',
  FAILED: 'FAILED'
}



export const IdentityDocumentType = {
  PASSPORT: 'PASSPORT',
  CNI: 'CNI'
}



export const PhoneNumberType = {
  PRINCIPAL: 'PRINCIPAL',
  LANDLINE: 'LANDLINE',
  WORK: 'WORK',
  OTHER: 'OTHER'
}



export const PromotionalCodeRouteRole = {
  ORIGIN: 'ORIGIN',
  DESTINATION: 'DESTINATION'
}



export const PromoDiscountScope = {
  PER_PASSENGER: 'PER_PASSENGER',
  PER_BOOKING: 'PER_BOOKING'
}



export const SmsMessageType = {
  TRANSACTIONAL: 'TRANSACTIONAL',
  MARKETING: 'MARKETING'
}



export const SmsStatus = {
  QUEUED: 'QUEUED',
  SENDING: 'SENDING',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
  UNSUBSCRIBED: 'UNSUBSCRIBED'
}



export const TaskStatus = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE'
}

